import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../../views/pages/manage/common/constant";
import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod"
import { getDropdownFromArrayList } from "./constant";

export const getDropdowns = async (selectedTabKey) => {
  switch (selectedTabKey) {
    case 'regionMapping': {
      const [phoenixData, honoData] = await Promise.all([
        dropdownMapping(`${endpoint.region.getAllActive}?regionType=${"HONO,REGULAR,BOTH"}`, "regionDispValue", 'id'),
        fetchAllPromisedData(endpoint.honoMapping.region),
      ]);
      return {
        regionMapping: {
          phoenixValueId: phoenixData,
          honoValue: getDropdownFromArrayList(honoData),
        },
      };
    }

    case 'jobTitleMapping': {
      const [phoenixData, honoData] = await Promise.all([
        dropdownMapping(endpoint.jobTitle.getAllActive, "jobTitleDispValue", 'id'),
        fetchAllPromisedData(endpoint.honoMapping.jobTitle),
      ]);
      return {
        jobTitleMapping: {
          phoenixValueId: phoenixData,
          honoValue: getDropdownFromArrayList(honoData),
        },
      };
    }

    case 'departmentMapping': {
      const [phoenixData, honoData] = await Promise.all([
        dropdownMapping(endpoint.departmentType.getAll, "departmentTypeDispValue", 'id'),
        fetchAllPromisedData(endpoint.honoMapping.department),
      ]);
      return {
        departmentMapping: {
          phoenixValueId: phoenixData,
          honoValue: getDropdownFromArrayList(honoData),
        },
      };
    }

    default:
      return {};
  }
};

export const getMapping=()=>{

}